import { render, staticRenderFns } from "./RemoveSite.vue?vue&type=template&id=a1535c04&scoped=true&"
import script from "./RemoveSite.vue?vue&type=script&lang=js&"
export * from "./RemoveSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1535c04",
  null
  
)

export default component.exports